import { bytesToObjectUrl, triggerDownload } from './mediaCache.ts'
import { docPreviewKind } from './documentPreview.ts'
import { escapeHtml } from '../ui/dom.ts'

let modal: HTMLElement | null = null
let activeUrl: string | null = null
let viewerBytes: Uint8Array | null = null
let viewerMime = 'application/octet-stream'
let viewerName = 'documento'

function ensureModal(): HTMLElement {
  if (modal) return modal
  modal = document.createElement('div')
  modal.id = 'doc-viewer-modal'
  modal.className = 'modal-overlay doc-viewer-overlay'
  modal.hidden = true
  modal.innerHTML = `
    <div class="card modal-card doc-viewer-card">
      <header class="doc-viewer-header">
        <h3 class="doc-viewer-title">Documento</h3>
        <button type="button" class="icon-btn doc-viewer-close" aria-label="Chiudi">✕</button>
      </header>
      <div class="doc-viewer-body"></div>
      <div class="row-btns doc-viewer-actions">
        <button type="button" class="doc-viewer-download">SCARICA</button>
        <button type="button" class="secondary doc-viewer-close-btn">Chiudi</button>
      </div>
    </div>
  `
  document.body.append(modal)
  const close = () => closeDocumentViewerModal()
  modal.querySelector('.doc-viewer-close')!.addEventListener('click', close)
  modal.querySelector('.doc-viewer-close-btn')!.addEventListener('click', close)
  modal.addEventListener('click', (e) => {
    if (e.target === modal) close()
  })
  modal.querySelector('.doc-viewer-download')!.addEventListener('click', () => {
    if (viewerBytes) triggerDownload(viewerBytes, viewerMime, viewerName)
  })
  return modal
}

export function closeDocumentViewerModal(): void {
  if (!modal) return
  modal.hidden = true
  document.body.style.overflow = ''
  if (activeUrl) {
    URL.revokeObjectURL(activeUrl)
    activeUrl = null
  }
  viewerBytes = null
  const body = modal.querySelector('.doc-viewer-body') as HTMLElement
  body.innerHTML = ''
}

export function openDocumentViewerModal(bytes: Uint8Array, mime: string, fileName: string): void {
  const m = ensureModal()
  closeDocumentViewerModal()

  viewerBytes = bytes
  viewerMime = mime || 'application/octet-stream'
  viewerName = fileName || 'documento'

  const kind = docPreviewKind(viewerMime, viewerName)
  const title = m.querySelector('.doc-viewer-title') as HTMLElement
  const body = m.querySelector('.doc-viewer-body') as HTMLElement
  title.textContent = viewerName

  if (kind === 'pdf') {
    activeUrl = bytesToObjectUrl(bytes, 'application/pdf')
    body.innerHTML = `<iframe class="doc-viewer-iframe" src="${activeUrl}" title="${escapeHtml(viewerName)}"></iframe>`
  } else if (kind === 'text') {
    const text = new TextDecoder('utf-8', { fatal: false }).decode(bytes)
    body.innerHTML = `<pre class="doc-viewer-text">${escapeHtml(text)}</pre>`
  } else {
    activeUrl = bytesToObjectUrl(bytes, viewerMime)
    body.innerHTML = `<iframe class="doc-viewer-iframe" src="${activeUrl}" title="${escapeHtml(viewerName)}"></iframe>`
  }

  m.hidden = false
  document.body.style.overflow = 'hidden'
}
